import { clearOrganizationState } from './organizationStorage'

const AUTH_TOKEN_KEY = 'authtoken'
const USER_KEY = 'user'
const TABLE_FILTER_KEYS = [
  'af.global.groupFilter',
  'af.my.participantsFilter',
  'af.history.participantsFilter',
  'af.all.participantsFilter',
  'af.all.alarmFilters',
  'af.all.durationFilters',
  'af.my.alarmFilters',
  'af.my.durationFilters',
  'af.history.alarmFilters',
  'af.history.durationFilters'
]

function readJson(key, fallback) {
  const raw = localStorage.getItem(key)

  if (!raw) {
    return fallback
  }

  try {
    return JSON.parse(raw)
  } catch (error) {
    return fallback
  }
}

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY)
}

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token)
    return
  }

  localStorage.removeItem(AUTH_TOKEN_KEY)
}

export function getStoredUser() {
  return readJson(USER_KEY, null)
}

export function clearAuthData() {
  localStorage.removeItem(AUTH_TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  clearOrganizationState()
}

export function clearStoredTableFilters() {
  TABLE_FILTER_KEYS.forEach((key) => {
    localStorage.removeItem(key)
  })
}
